var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('m-theme',{class:_vm.$s.PopoverContent,style:(_vm.styles),attrs:{"theme":_vm.theme}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }